import { useEffect, useState } from 'react';
import { ContactPage, ManageAccounts, Cancel, KeyOutlined } from '@mui/icons-material';

// material-ui
import {
    Box,
    Button,
    Grid,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Modal,
    TextField,
    FormControl,
    Select,
    MenuItem,
    Autocomplete,
    CircularProgress,
    Checkbox
} from '@mui/material';

import { useTheme } from '@mui/material/styles';
import { deepPurple } from '@mui/material/colors';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { gridSpacing } from 'app/constant';

import { useSelector } from 'react-redux';
import { selectCurrentUser, selectCurrentToken } from 'features/auth/authSlice';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { axiosInstance } from 'utils/axios';
import { toast } from 'react-toastify';

import { useTranslation } from "react-i18next";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 900,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const columns = [
    { id: 'id', label: '#', minWidth: 30 },
    { id: 'userName', label: '代理名字', minWidth: 170 },
    { id: 'waUrl', label: 'Whatsapp网址', minWidth: 170 },
    { id: 'telegramUrl', label: 'Telegram网址', minWidth: 170 },
    { id: 'telegramUrl2', label: 'Telegram网址 2', minWidth: 170 },
    { id: 'telegramUrl3', label: 'Telegram网址 3', minWidth: 170 },
];

const ViewDetailsModal = ({ id }) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const token = useSelector(selectCurrentToken);
    const [saleDetails, setSaleDetails] = useState({});

    const fetchSalesDetails = async () => {
        try {
            const res = await axiosInstance.get(`/Sales/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setSaleDetails(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (open) {
            fetchSalesDetails();
        }
    }, [open]);

    return (
        <div>
            <Button
                onClick={handleOpen}
                sx={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    width: 'fit-content',
                    height: 'fit-content',
                    color: deepPurple[500]
                }}
            >
                <ContactPage />
            </Button>
            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Typography id="modal-modal-title" variant="h3" component="h2">
                            Users Records Details
                        </Typography>
                        <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                    </Box>

                    <Box
                        id="modal-modal-description"
                        sx={{
                            height: '400px',
                            overflowY: 'auto'
                        }}
                    >
                        <Grid item container xs={12} sx={{ mt: 2 }}>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Client Name : <span style={{ fontWeight: 600 }}>{saleDetails.clientName}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Amount : <span style={{ fontWeight: 600 }}>{saleDetails.amount}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Status : <span style={{ fontWeight: 600 }}>{saleDetails.statusName}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Package Name : <span style={{ fontWeight: 600 }}>{saleDetails.packageName}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Third Party Name : <span style={{ fontWeight: 600 }}>{saleDetails.thirdPartyName}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Third Party Charges : <span style={{ fontWeight: 600 }}>{saleDetails.thirdPartyCharges}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Third Party Charges Type :{' '}
                                    <span style={{ fontWeight: 600 }}>{saleDetails.thirdPartyChargesTypeName}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Estimated Profit : <span style={{ fontWeight: 600 }}>{saleDetails.estimatedProfit}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Estimated Daily Profit Profit :{' '}
                                    <span style={{ fontWeight: 600 }}>{saleDetails.estimatedDailyProfit}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Converted Amount : <span style={{ fontWeight: 600 }}>{saleDetails.convertedAmountString}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Created By : <span style={{ fontWeight: 600 }}>{saleDetails.createdBy}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Created Date :{' '}
                                    <span style={{ fontWeight: 600 }}>
                                        {saleDetails.createdDate &&
                                            `${saleDetails.createdDate?.split('T')[0]} 
                  ${new Date('1970-01-01T' + saleDetails.createdDate?.split('T')[1] + 'Z').toLocaleTimeString('en-US', {
                      timeZone: 'UTC',
                      hour12: true,
                      hour: 'numeric',
                      minute: 'numeric',
                      second: 'numeric'
                  })}`}
                                    </span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Updated By : <span style={{ fontWeight: 600 }}>{saleDetails.updatedBy}</span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Updated Date :{' '}
                                    <span style={{ fontWeight: 600 }}>
                                        {saleDetails.updatedDate &&
                                            `${saleDetails.updatedDate?.split('T')[0]} 
                  ${new Date('1970-01-01T' + saleDetails.updatedDate?.split('T')[1] + 'Z').toLocaleTimeString('en-US', {
                      timeZone: 'UTC',
                      hour12: true,
                      hour: 'numeric',
                      minute: 'numeric',
                      second: 'numeric'
                  })}`}
                                    </span>
                                </Typography>
                            </Grid>
                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    User Name : <span style={{ fontWeight: 600 }}>{saleDetails.userName}</span>
                                </Typography>
                            </Grid>

                            <Grid item container xs={12} md={6} sx={{ mt: 2 }}>
                                <Typography
                                    sx={{
                                        fontSize: '16px'
                                    }}
                                >
                                    Approved Date :{' '}
                                    <span style={{ fontWeight: 600 }}>
                                        {saleDetails.approvedDate &&
                                            `${saleDetails.approvedDate?.split('T')[0]} 
                  ${new Date('1970-01-01T' + saleDetails.approvedDate?.split('T')[1] + 'Z').toLocaleTimeString('en-US', {
                      timeZone: 'UTC',
                      hour12: true,
                      hour: 'numeric',
                      minute: 'numeric',
                      second: 'numeric'
                  })}`}
                                    </span>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Modal>
        </div>
    );
};

const UserRecord = () => {
    const { t } = useTranslation();

    const user = useSelector(selectCurrentUser);
    const token = useSelector(selectCurrentToken);
    const theme = useTheme();
    const [expensesTypes, setExpensesTypes] = useState([]);
    const [thirdparty, setThirdParty] = useState([]);
    const [packages, setPackages] = useState([]);
    const [userStatus, setUsersStatus] = useState([]);
    const [users, setUsers] = useState([]);
    const [filterSalesFrom, setFilerSalesFrom] = useState(dayjs().subtract(1, 'days'));
    const [filterSalesTo, setFilerSalesTo] = useState(dayjs());
    const [filterSalesClientName, setFilterSalesClientName] = useState('');
    const [filterSalesStatus, setFilterSalesStatus] = useState('');
    const [filterSalesPackage, setFilterSalesPackage] = useState('');
    const [filterSalesThirdParty, setFilterSalesThirdParty] = useState('');
    const [customerNameOptions, setCustomerNameOptions] = useState([]);
    const [currencies, setCurrencies] = useState([]);
    const [isLoading, setLoading] = useState(true);

    const [filterBtnDisabled, setFilterBtnDisabled] = useState(false);

    const warningAlert = (message) => {
        toast.warning(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const successAlert = (message) => {
        toast.success(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    const errorAlert = (message) => {
        toast.error(message, {
            position: toast.POSITION.TOP_CENTER
        });
    };

    //fetch customer names for autocomplete start
    const fetchCustomerNamesOptions = async () => {
        try {
            const res = await axiosInstance.get('/Customer/Names', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setCustomerNameOptions(res.data);
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch customer names for autocomplete end

    //fetch expenses types start
    const fetchExpensesTypes = async () => {
        try {
            const res = await axiosInstance.get('/ExpensesType', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setExpensesTypes(res.data);
            } else {
                errorAlert('Something Went Wrong');
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch expenses types end

    //fetch available packages start
    const fetchPackages = async () => {
        try {
            const res = await axiosInstance.get('/AvailablePackage', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setPackages(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch availabel packages end

    //fetch third party start
    const fetchThirdParty = async () => {
        try {
            const res = await axiosInstance.get('/Project', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setThirdParty(res.data);
            } else {
                errorAlert('Something went wrong');
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch third party end

    const fetchSalesStatus = async () => {
        try {
            const res = await axiosInstance.get('/SalesStatus', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setUsersStatus(res.data);
            } else {
                errorAlert('Something went wrong');
            }
        } catch (error) {
            console.log(error);
        }
    };

    //fetch currency start
    const fetchCurrency = async () => {
        try {
            const res = await axiosInstance.get('/Currency', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setCurrencies(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        }
    };
    //fetch currency end

    //fetch sales start
    const [fetchUserLoading, setFetchUserLoading] = useState(false);
    const fetchUsers = async () => {
        setFilterBtnDisabled(true);

        if (!filterSalesFrom.isValid() || !filterSalesTo.isValid()) {
            warningAlert('Please fill all required fields.');
            return;
        }
        let usersURL = `/User/All?dateFrom=${filterSalesFrom.format('YYYY-MM-DD')}&dateTo=${filterSalesTo.format('YYYY-MM-DD')}`;
        if (filterSalesClientName !== '') {
            usersURL += `&clientName=${filterSalesClientName}`;
        }
        if (filterSalesStatus !== '') {
            usersURL += `&statusID=${filterSalesStatus}`;
        }
        if (filterSalesPackage !== '') {
            usersURL += `&packageID=${filterSalesPackage}`;
        }
        if (filterSalesThirdParty !== '') {
            usersURL += `&thirdPartyID=${filterSalesThirdParty}`;
        }
        setFetchUserLoading(true);
        try {
            const res = await axiosInstance.get(usersURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setUsers(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setFetchUserLoading(false);
            setFilterBtnDisabled(false);
        }
    };
    //fetch sales end

    //insert sales start
    const InsertUserRecord = () => {
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);

        const [addName, setAddName] = useState('');
        const [addUserName, setAddUserName] = useState('');
        const [addPassword, setAddPassword] = useState('');
        const [addIsAdmin, setAddIsAdmin] = useState(false);
        const [addIsSupervisor, setAddIsSupervisor] = useState(false);
        const [addProjectID, setAddProjectID] = useState('');
        const [addAgentCode, setAddAgentCode] = useState('');
        const [addPhoneNumber, setAddPhoneNumber] = useState('');
        const [addWAUrl, setAddWAUrl] = useState('');
        const [addTelegramUrl, setAddTelegramUrl] = useState('');

        const [createBtnDisabled, setCreateBtnDisabled] = useState(false);
        const [insertUserLoading, setInsertUserLoading] = useState(false);

        const submitUserCreate = async (e) => {
            setCreateBtnDisabled(true);
            setTimeout(() => {
                setCreateBtnDisabled(false);
            }, 3000);

            const isAdmin = addIsAdmin === 'true';
            const isSupervisor = addIsSupervisor === 'true';

            if (
                addName === '' ||
                addUserName === '' ||
                addPassword === '' ||
                (isAdmin !== true && isAdmin !== false) ||
                (isSupervisor !== true && isSupervisor !== false) ||
                (addProjectID === 0 && addProjectID === '')
            ) {
                warningAlert('Please fill all required fields.');
                return;
            }

            setInsertUserLoading(true);
            try {
                const res = await axiosInstance.post(
                    '/User',
                    {
                        Name: addName,
                        Username: addUserName,
                        Password: addPassword,
                        IsAdmin: isAdmin,
                        IsSupervisor: isSupervisor,
                        ProjectID: addProjectID,
                        agentCode: addAgentCode,
                        phoneNumber: addPhoneNumber,
                        waUrl: addWAUrl,
                        telegramUrl: addTelegramUrl
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('Sales created successfully.');
                    fetchUsers();
                } else {
                    errorAlert('Something went wrong.');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setInsertUserLoading(false);
            }
        };

        return (
            <>
                {/* <Button
                    onClick={handleOpen}
                    sx={{
                        border: 'none',
                        backgroundColor: deepPurple[500],
                        color: 'white',
                        marginLeft: 'auto',
                        marginBottom: '20px',
                        marginRight: '20px'
                    }}
                >
                    Add User
                </Button> */}

                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    {insertUserLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={style}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Typography id="modal-modal-title" variant="h3" component="h2">
                                    Add User
                                </Typography>
                                <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                            <Box
                                id="modal-modal-description"
                                sx={{
                                    height: '350px',
                                    overflowY: 'auto'
                                }}
                            >
                                <Grid item container xs={12} sx={{ mt: 2 }}>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Name :
                                            </Typography>
                                            <input
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={addName}
                                                onChange={(e) => setAddName(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>
                                                Username :
                                            </Typography>
                                            <input
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={addUserName}
                                                onChange={(e) => setAddUserName(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>
                                                Password :
                                            </Typography>
                                            <input
                                                type="password"
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={addPassword}
                                                onChange={(e) => setAddPassword(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Is Admin
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={addIsAdmin}
                                                onChange={(e) => setAddIsAdmin(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="true">
                                                    True
                                                </MenuItem>
                                                <MenuItem sx={{ width: '100%' }} value="false">
                                                    False
                                                </MenuItem>
                                            </Select>
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>
                                                Is Supervisor
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={addIsSupervisor}
                                                onChange={(e) => setAddIsSupervisor(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="true">
                                                    True
                                                </MenuItem>
                                                <MenuItem sx={{ width: '100%' }} value="false">
                                                    False
                                                </MenuItem>
                                            </Select>
                                        </Box>
                                    </Grid>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>
                                                Project ID :
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={addProjectID}
                                                onChange={(e) => setAddProjectID(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="">
                                                    Select Project
                                                </MenuItem>
                                                {thirdparty.map((item, index) => {
                                                    return (
                                                        <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                            {item.projectName}
                                                        </MenuItem>
                                                    );
                                                })}
                                            </Select>
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>
                                                Agent Code :
                                            </Typography>
                                            <input
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={addAgentCode}
                                                onChange={(e) => setAddAgentCode(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>
                                                Phone Number :
                                            </Typography>
                                            <input
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={addPhoneNumber}
                                                onChange={(e) => setAddPhoneNumber(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Whatsapp Group Link :
                                            </Typography>
                                            <input
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={addWAUrl}
                                                onChange={(e) => setAddWAUrl(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Telegram Group Link :
                                            </Typography>
                                            <input
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={addTelegramUrl}
                                                onChange={(e) => setAddTelegramUrl(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: deepPurple[500],
                                    marginTop: '50px'
                                }}
                                onClick={() => submitUserCreate()}
                                disabled={createBtnDisabled}
                            >
                                Create
                            </Button>
                        </Box>
                    )}
                </Modal>
            </>
        );
    };
    //insert sales end

    //update sales start
    const UpdateUserRecord = ({ user }) => {
        const { t } = useTranslation();

        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);

        const [addUserName, setAddUserName] = useState('');
        const [addPassword, setAddPassword] = useState('');
        const [addIsAdmin, setAddIsAdmin] = useState(user.isAdmin);
        const [addIsSupervisor, setAddIsSupervisor] = useState(user.isSupervisor);
        const [updateIsDisable, setUpdateIsDisable] = useState(user.isDisabled);
        const [addProjectID, setAddProjectID] = useState(user.projectID);
        const [addAgentCode, setAddAgentCode] = useState(user.agentCode);
        const [addPhoneNumber, setAddPhoneNumber] = useState(user.phoneNumber);
        const [addWAUrl, setAddWAUrl] = useState(user.waUrl);
        const [addTelegramUrl, setAddTelegramUrl] = useState(user.telegramUrl);
        const [addIsPopUpJoinGroup, setAddIsPopUpJoinGroup] = useState(user.isPopUpJoinGroup);
        const [addTelegramUrl2, setAddTelegramUrl2] = useState(user.telegramUrl2);
        const [addTelegramUrl3, setAddTelegramUrl3] = useState(user.telegramUrl3);

        const [updateBtnDisabled, setUpdateBtnDisabled] = useState(false);
        const [updateUserLoading, setUpdateUserLoading] = useState(false);

        const submitUpdateUser = async () => {
            setUpdateBtnDisabled(true);
            setTimeout(() => {
                setUpdateBtnDisabled(false);
            }, 3000);

            const isAdmin = addIsAdmin && addIsAdmin.toString() === 'true';
            const isSupervisor = addIsSupervisor && addIsSupervisor.toString() === 'true';
            const isUserDisabled = updateIsDisable && updateIsDisable.toString() === 'true';


            if (
                user?.userID === 0 ||
                (isAdmin !== true && isAdmin !== false) ||
                (isSupervisor !== true && isSupervisor !== false) ||
                (isUserDisabled !== true && isUserDisabled !== false) ||
                (addProjectID === '' && addProjectID === 0)
            ) {
                warningAlert('Please fill all required fields.');
                return;
            }
            setUpdateUserLoading(true);
            try {
                const res = await axiosInstance.put(
                    '/User',
                    {
                        UserID: user?.userID,
                        IsAdmin: isAdmin,
                        IsSupervisor: isSupervisor,
                        ProjectID: addProjectID,
                        IsDisabled: isUserDisabled,
                        agentCode: addAgentCode,
                        phoneNumber: addPhoneNumber,
                        waUrl: addWAUrl,
                        telegramUrl: addTelegramUrl,
                        isPopUpJoinGroup: addIsPopUpJoinGroup,
                        telegramUrl2: addTelegramUrl2,
                        telegramUrl3: addTelegramUrl3
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('Sales updated successfully.');
                    fetchUsers();
                } else {
                    errorAlert('Something went wrong.');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setUpdateUserLoading(false);
            }
        };

        return (
            <>
                <Button
                    onClick={handleOpen}
                    sx={{
                        border: 'none',
                        backgroundColor: 'transparent',
                        width: 'fit-content',
                        height: 'fit-content',
                        color: deepPurple[500]
                    }}
                >
                    <ManageAccounts />
                </Button>

                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    {updateUserLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={style}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Typography id="modal-modal-title" variant="h3" component="h2">
                                    {t("user.updateAdmin")}
                                </Typography>
                                <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                            <Box
                                id="modal-modal-description"
                                sx={{
                                    height: '30vh',
                                    overflowY: 'auto'
                                }}
                            >
                                <Grid item container xs={12} sx={{ mt: 2 }}>
                                    {/* <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>Is Admin
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={addIsAdmin}
                                                onChange={(e) => setAddIsAdmin(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="true">
                                                    True
                                                </MenuItem>
                                                <MenuItem sx={{ width: '100%' }} value="false">
                                                    False
                                                </MenuItem>
                                            </Select>
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>
                                                Is Supervisor
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={addIsSupervisor}
                                                onChange={(e) => setAddIsSupervisor(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="">
                                                    Is Supervisor
                                                </MenuItem>
                                                <MenuItem sx={{ width: '100%' }} value="true">
                                                    True
                                                </MenuItem>
                                                <MenuItem sx={{ width: '100%' }} value="false">
                                                    False
                                                </MenuItem>
                                            </Select>
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>
                                                Is Disable
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={updateIsDisable}
                                                onChange={(e) => setUpdateIsDisable(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                <MenuItem sx={{ width: '100%' }} value="true">
                                                    True
                                                </MenuItem>
                                                <MenuItem sx={{ width: '100%' }} value="false">
                                                    False
                                                </MenuItem>
                                            </Select>
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>
                                                Project ID :
                                            </Typography>
                                            <Select
                                                displayEmpty
                                                value={addProjectID}
                                                onChange={(e) => setAddProjectID(e.target.value)}
                                                // sx={{width:"100%"}}
                                            >
                                                {thirdparty.map((item, index) => {
                                                    return (
                                                        <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                                            {item.projectName}
                                                        </MenuItem>
                                                    );
                                                })}
                                            </Select>
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>
                                                Agent Code :
                                            </Typography>
                                            <input
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={addAgentCode}
                                                onChange={(e) => setAddAgentCode(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                <span style={{ color: 'red' }}>*</span>
                                                Phone Number :
                                            </Typography>
                                            <input
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={addPhoneNumber}
                                                onChange={(e) => setAddPhoneNumber(e.target.value)}
                                            />
                                        </Box>
                                    </Grid> */}

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {t("user.whatsappUrl")} :
                                            </Typography>
                                            <input
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={addWAUrl}
                                                onChange={(e) => setAddWAUrl(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {t("user.telegramUrl")} :
                                            </Typography>
                                            <input
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={addTelegramUrl}
                                                onChange={(e) => setAddTelegramUrl(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {t("user.telegramUrl2")} :
                                            </Typography>
                                            <input
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={addTelegramUrl2}
                                                onChange={(e) => setAddTelegramUrl2(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {t("user.telegramUrl3")} :
                                            </Typography>
                                            <input
                                                style={{ width: '100%', height: '50px', borderRadius: '10px' }}
                                                value={addTelegramUrl3}
                                                onChange={(e) => setAddTelegramUrl3(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>

                                    {/* <Grid item container xs={12} md={6} sx={{ mt: 3 }} pl={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                Is Join Group Pop Up :
                                            </Typography>
                                            <Checkbox
                                                checked={addIsPopUpJoinGroup}
                                                onChange={(e) => setAddIsPopUpJoinGroup(e.target.checked)} // Use checked value directly
                                            />
                                        </Box>
                                    </Grid> */}
                                </Grid>
                            </Box>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: deepPurple[500],
                                    marginTop: '50px'
                                }}
                                onClick={() => submitUpdateUser()}
                                disabled={updateBtnDisabled}
                            >
                                {t("user.confirmUpdate")}
                            </Button>
                        </Box>
                    )}
                </Modal>
            </>
        );
    };
    //update sales end

    // update HelpAgentChangePasswordModal Password
    const HelpAgentChangePasswordModal = ({ user }) => {
        const [open, setOpen] = useState(false);
        const handleOpen = () => setOpen(true);
        const handleClose = () => setOpen(false);
        const token = useSelector(selectCurrentToken);
        const [isLoading, setIsLoading] = useState(true);

        const [userPassword, setUserPassword] = useState('');
        const [updateBtnDisabled, setUpdateBtnDisabled] = useState(false);
        const [updateUserPasswordLoading, setUpdateUserPasswordLoading] = useState(false);

        useEffect(() => {
            setIsLoading(false);
        }, []);

        const submitUserPassword = async () => {
            setUpdateBtnDisabled(true);
            setTimeout(() => {
                setUpdateBtnDisabled(false);
            }, 3000);

            if (user.id === null || userPassword === '') {
                warningAlert('Please Fill all required fields.');
                return;
            }
            setUpdateUserPasswordLoading(true);
            try {
                const res = await axiosInstance.put(
                    '/UserPassword',
                    {
                        userID: user.id,
                        newPassword: userPassword
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

                if (res.status === 200) {
                    setOpen(false);
                    setUserPassword('');
                    successAlert('Succesfully Updated User password.');
                } else {
                    errorAlert('Something went wrong.');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setUpdateUserPasswordLoading(false);
            }
        };

        return (
            <div>
                <Button
                    onClick={handleOpen}
                    sx={{
                        border: 'none',
                        backgroundColor: 'transparent',
                        width: 'fit-content',
                        height: 'fit-content',
                        color: deepPurple[500]
                    }}
                >
                    <KeyOutlined />
                </Button>
                <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    {updateUserPasswordLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={style}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <Typography id="modal-modal-title" variant="h3" component="h2">
                                    {t("user.changeAdminPassword")}
                                </Typography>
                                <Cancel onClick={handleClose} sx={{ width: '30px', height: '30px' }} />
                            </Box>
                            <Box
                                id="modal-modal-description"
                                sx={{
                                    height: '300px',
                                    overflowY: 'auto'
                                }}
                            >
                                <Grid item container xs={12} sx={{ mt: 2 }}>
                                    <Grid item container xs={12} md={6} sx={{ mt: 3 }} pr={{ md: '5px' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Typography
                                                sx={{
                                                    fontSize: '16px',
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {t("user.password")} :
                                            </Typography>
                                            <TextField
                                                type="text"
                                                id="outlined-basic"
                                                variant="outlined"
                                                isLoading={isLoading}
                                                value={userPassword}
                                                onChange={(e) => setUserPassword(e.target.value)}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Button
                                variant="contained"
                                sx={{
                                    display: 'block',
                                    mx: 'auto',
                                    width: '150px',
                                    backgroundColor: deepPurple[500],
                                    marginTop: '50px'
                                }}
                                onClick={() => submitUserPassword()}
                                disabled={updateBtnDisabled}
                            >
                                {t("user.confirmUpdate")}
                            </Button>
                        </Box>
                    )}
                </Modal>
            </div>
        );
    };

    useEffect(() => {
        setLoading(false);

        Promise.all([
            fetchExpensesTypes(),
            fetchPackages(),
            fetchUsers(),
            fetchThirdParty(),
            fetchSalesStatus(),
            fetchCustomerNamesOptions(),
            fetchCurrency()
        ]).catch((error) => {
            // Handle errors if any of the promises fail
            console.error('An error occurred:', error);
        });
    }, []);

    //sales table start
    function StickyHeadTable() {
        const [page, setPage] = useState(0);
        const [rowsPerPage, setRowsPerPage] = useState(100);

        const handleChangePage = (event, newPage) => {
            setPage(newPage);
        };

        const handleChangeRowsPerPage = (event) => {
            setRowsPerPage(+event.target.value);
            setPage(0);
        };

        return (
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                <TableContainer sx={{ maxHeight: 440 }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell key="id" style={{ minWidth: 30 }}>{t("user.createdDate")}</TableCell>
                                <TableCell key="userName" style={{ minWidth: 170 }}>{t("user.adminName")}</TableCell>
                                <TableCell key="waUrl" style={{ minWidth: 170 }}>{t("user.whatsappUrl")}</TableCell>
                                <TableCell key="telegramUrl" style={{ minWidth: 170 }}>{t("user.telegramUrl")}</TableCell>
                                <TableCell key="telegramUrl2" style={{ minWidth: 170 }}>{t("user.telegramUrl2")}</TableCell>
                                <TableCell key="telegramUrl3" style={{ minWidth: 170 }}>{t("user.telegramUrl3")}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {users.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                        {columns.map((column) => {
                                            let value = row[column.id];
                                            if (column.type && column.type === 'date') {
                                                if (value) {
                                                    const timeString12hr = new Date(
                                                        '1970-01-01T' + value.split('T')[1] + 'Z'
                                                    ).toLocaleTimeString('en-US', {
                                                        timeZone: 'UTC',
                                                        hour12: true,
                                                        hour: 'numeric',
                                                        minute: 'numeric',
                                                        second: 'numeric'
                                                    });
                                                    value = `${value.split('T')[0]} ${timeString12hr}`;
                                                }
                                            }
                                            return (
                                                <TableCell key={column.id} align={column.align}>
                                                    {typeof value === 'boolean'
                                                        ? value.toString()
                                                        : column.format && typeof value === 'number'
                                                        ? column.format(value)
                                                        : value}
                                                </TableCell>
                                            );
                                        })}
                                        <TableCell>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '10px'
                                                }}
                                            >
                                                {/* <ViewDetailsModal id={row.id} /> */}
                                                <UpdateUserRecord user={row} />
                                                <HelpAgentChangePasswordModal user={row} />
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={users.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        );
    }
    //sales table end

    return (
        <Grid container item xs={12}>
            <InsertUserRecord />
            <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '10px', overflowY: 'auto' }}>
                <Grid item container xs={12} md={6} lg={6}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>{t("withdrawal.createdDate")} :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterSalesFrom}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilerSalesFrom(newValue)}
                            />
                        </LocalizationProvider>
                        -
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterSalesTo}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilerSalesTo(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>
                {/* <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <span style={{ color: 'red' }}>*</span>To :
                        </Typography>
                    </Box>
                </Grid> */}
                {/* <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Client Name :
                        </Typography>
                        <Autocomplete
                            freeSolo
                            value={filterSalesClientName}
                            onChange={(event, newValue) => {
                                setFilterSalesClientName(newValue);
                            }}
                            inputValue={filterSalesClientName}
                            onInputChange={(event, newInputValue) => {
                                setFilterSalesClientName(newInputValue);
                            }}
                            id="controllable-states-demo"
                            options={customerNameOptions}
                            sx={{ width: 170 }}
                            renderInput={(params) => <TextField {...params} />}
                            disableClearable
                        />
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Package :
                        </Typography>
                        <Select
                            displayEmpty
                            value={filterSalesPackage}
                            onChange={(e) => setFilterSalesPackage(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                Select Package
                            </MenuItem>
                            {packages.map((item, index) => (
                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Status :
                        </Typography>
                        <Select
                            displayEmpty
                            value={filterSalesStatus}
                            onChange={(e) => setFilterSalesStatus(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                Select Status
                            </MenuItem>
                            {userStatus.map((item, index) => (
                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Third Party :
                        </Typography>
                        <Select
                            displayEmpty
                            value={filterSalesThirdParty}
                            onChange={(e) => setFilterSalesThirdParty(e.target.value)}
                            // sx={{width:"100%"}}
                        >
                            <MenuItem sx={{ width: '100%' }} value="">
                                Select Third Party
                            </MenuItem>
                            {thirdparty.map((item, index) => (
                                <MenuItem sx={{ width: '100%' }} value={item.id} key={index}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                </Grid> */}

                <Button
                    variant="contained"
                    sx={{
                        display: 'block',
                        mx: 'auto',
                        width: '150px',
                        backgroundColor: deepPurple[500],
                        marginTop: '20px',
                        marginBottom: '20px'
                    }}
                    onClick={() => fetchUsers()}
                    disabled={filterBtnDisabled}
                >
                    {t("withdrawal.filter")}
                </Button>
            </Grid>
            <Box sx={{ width: '100%', minHeight: '200px' }}>
                {fetchUserLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <StickyHeadTable />
                )}
            </Box>
        </Grid>
    );
};

export default UserRecord;
